import KeyIcon from "@/assets/icons/key.svg";

import StatusPage from "..";

export type NotAllowedProps = { className?: string };

const NotAllowed: React.FunctionComponent<NotAllowedProps> = () => {
  return (
    <StatusPage
      data-testid="not-allowed"
      icon={KeyIcon}
      title={L.STATUS_PAGE_NOT_ALLOWED_TITLE}
      subtitle={L.STATUS_PAGE_NOT_ALLOWED_SUBTITLE}
    />
  );
};

export default NotAllowed;
